/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createnewbusinessdescription3Inputs */

const en_createnewbusinessdescription3 = /** @type {(inputs: Createnewbusinessdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a business account for a client. They will receive an email to set their password.`)
};

const de_createnewbusinessdescription3 = /** @type {(inputs: Createnewbusinessdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstell ein Business-Konto für einen Kunden. Er bekommt eine E-Mail, um sein Passwort festzulegen.`)
};

/**
* | output |
* | --- |
* | "Create a business account for a client. They will receive an email to set their password." |
*
* @param {Createnewbusinessdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createnewbusinessdescription3 = /** @type {((inputs?: Createnewbusinessdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createnewbusinessdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createnewbusinessdescription3(inputs)
	return de_createnewbusinessdescription3(inputs)
});
export { createnewbusinessdescription3 as "createNewBusinessDescription" }